<template>
  <div class=" px-9">
    <div v-if="posts" class="mb-16">
      <PostView :posts="posts" />
    </div>
    <router-link :to="{ name: 'CreatePosts' }" class="bg-gray-900 text-gray-200 p-3 pl-4 pr-4 hover:bg-gray-800 rounded-lg">Create a New post</router-link>
  </div>
</template>

<script>
import getUser from "@/composables/getUser"
import getCollection from "@/composables/getCollection"
import PostView from "@/components/post/PostView.vue"
export default {
  components: { PostView },
  setup() {
    const { user } = getUser()
    const { documents: posts } = getCollection("posts", ["userId", "==", user.value.uid])
    return { posts }
  },
}
</script>

<style></style>
